/**
 * Used to check if a feature flag is enabled.
 */
export function useFeatureFlags() {
    const config = useRuntimeConfig();

    function isFeatureEnabled(name: FeatureFlag) {
        return config.public.featureFlags[name] ?? false;
    }

    return {
        isFeatureEnabled,
    };
}
